module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }